module.exports = __webpack_public_path__ + "img/math-subject.cd99e35.png";